import { z } from "zod"
import { debouncedValidatePhoneNumber } from "@/lib/validate-phone-number"
import { nonEmptyStringRequired, textAreaDefaultMaxLength } from "@/models/common"
import { phoneNumberValidation } from "@/modules/patients/components/phoneNumber/PhoneNumberInput"

const maxCharLimitMessage = "common.fieldErrorList.maxCharLimit"

export const careProviderSchemaBase = z.object({
  email: z
    .email({ message: "common.fieldErrorList.invalidEmail" })
    .max(254, { message: maxCharLimitMessage })
    .optional()
    .nullable()
    .or(z.literal("")),
  phoneNumber: z.string(),
  website: z.string().max(300, { message: maxCharLimitMessage }).nullable().optional(),
  country: z.string({ error: "common.fieldErrorList.requiredField" }).nullable(),
  postalCode: z.string().max(20, { message: maxCharLimitMessage }).nullable().optional(),
  city: z.string().max(100, { message: maxCharLimitMessage }).nullable().optional(),
  isMedgatePartnerNetworkMember: z.boolean(),
  isTakesNewPatients: z.boolean(),
})

export const careProviderSchema = careProviderSchemaBase.extend({
  phoneNumber: phoneNumberValidation(debouncedValidatePhoneNumber()),
})

export const sendMessageToAdminSchema = z.object({
  message: nonEmptyStringRequired.max(textAreaDefaultMaxLength),
})

export const reportToCloseSchema = z.object({
  confirmed: z.boolean().refine((val) => val === true, {
    message: "common.fieldErrorList.requiredField",
  }),
})

export type SendMessageToAdminSchema = z.infer<typeof sendMessageToAdminSchema>

export type ReportToCloseSchema = z.infer<typeof reportToCloseSchema>

export type CareProviderSchemaType = z.infer<typeof careProviderSchema>
